/* Stylesheet */

.segment_button {
  margin: 4px;
  --padding-top: 0;
  --border-radius: 52px;
  width: 100%;
  text-transform: none;
  --background-hover: var(--ion-color-dark-primary);
  --background-hover-opacity: 0.025;
  --color-checked: var(--ion-color-primary);
  --indicator-color: none;
  --ripple-color: transparent;
  box-shadow: var(--ion-box-shadow);
  overflow: hidden;

  .wrapper_container {
    display: flex;
    width: 100%;
    align-items: center;

    .icon {
      margin: 0px 12px 0px 0px;
      height: 14px;
      width: 14px;
    }

    .label {
      padding: 0px 21px 0px 21px;
      text-align: center;
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
